import { memo, useCallback, useSyncExternalStore } from "react";

import ModalComponent from "@zenith/components/ui/ModalComponent/modal-component/modal-component";
import {
  UNSTABLE_CONNECTION_MODAL_BODY,
  UNSTABLE_CONNECTION_MODAL_TITLE,
} from "@zenith/data/constants";
import {
  getUnstableConnectionSnapshot,
  snoozeUnstableConnection,
  subscribeNetworkHealth,
} from "@zenith/utils/Helpers/networkHealth";

/**
 * @component
 * @description
 */
const UnstableConnectionComponent = memo(
  function UnstableConnectionComponent() {
    const isUnstable = useSyncExternalStore(
      subscribeNetworkHealth,
      getUnstableConnectionSnapshot,
      () => false
    );

    const dismiss = useCallback(() => {
      snoozeUnstableConnection();
    }, []);

    return (
      <ModalComponent
        title={UNSTABLE_CONNECTION_MODAL_TITLE}
        body={UNSTABLE_CONNECTION_MODAL_BODY}
        showModal={isUnstable}
        onClickButton={dismiss}
        onClickClose={dismiss}
        buttonText="Close"
        icon="warning"
        showErrorIcon
      />
    );
  }
);

export default UnstableConnectionComponent;
